// extracted by mini-css-extract-plugin
export default {"recent":"RecentActivity_recent__QnqBs","recent__title":"RecentActivity_recent__title__G4UgI","svg":"RecentActivity_svg__yPCIy"};